export const RedirectUrlEnum = Object.freeze({
  DEBTOR_CHECKOUT: 'DEBTOR_CHECKOUT',
  DEBTOR_ACCOUNT_DETAILS: 'DEBTOR_ACCOUNT_DETAILS'
});